import React from 'react';
import { Link } from 'react-router-dom';
import Icon from '../../../components/AppIcon';

const HistoricalResultsLink = ({ previousSessions }) => {
  if (!previousSessions || previousSessions?.length === 0) return null;

  return (
    <div className="bg-card rounded-xl border border-border p-4 md:p-6">
      <div className="flex items-center justify-between mb-4">
        <div className="flex items-center gap-2">
          <Icon name="History" size={20} color="var(--color-primary)" />
          <h3 className="text-base md:text-lg font-semibold text-foreground">Previous Sessions</h3>
        </div>
        <Link 
          to="/history"
          className="text-sm text-primary hover:text-primary/80 transition-smooth font-medium"
        >
          View All
        </Link>
      </div>
      <div className="space-y-3">
        {previousSessions?.slice(0, 3)?.map((session) => (
          <Link
            key={session?.id}
            to={`/results/${session?.id}`}
            className="flex items-center justify-between p-3 rounded-lg bg-muted/30 hover:bg-muted/50 transition-smooth group"
          >
            <div className="flex items-center gap-3 flex-1 min-w-0">
              <div className="w-10 h-10 rounded-lg bg-primary/10 flex items-center justify-center flex-shrink-0">
                <Icon name="Image" size={18} color="var(--color-primary)" />
              </div>
              <div className="flex-1 min-w-0">
                <div className="text-sm font-medium text-foreground truncate">
                  {session?.photoCount} photos analyzed
                </div>
                <div className="text-xs text-muted-foreground caption">
                  {new Date(session.date)?.toLocaleDateString('en-US', { 
                    month: 'short', 
                    day: 'numeric', 
                    year: 'numeric' 
                  })}
                </div>
              </div>
            </div>
            <div className="flex items-center gap-2">
              <div className="text-sm font-semibold text-primary data-text">
                {session?.averageScore?.toFixed(1)}
              </div>
              <Icon 
                name="ChevronRight" 
                size={16} 
                color="var(--color-muted-foreground)"
                className="group-hover:translate-x-1 transition-smooth"
              />
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
};

export default HistoricalResultsLink;